import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from "../utils/pubsub"

import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import Spinner from '../ui-elements/Spinner'
import { useParams, useNavigate } from 'react-router-dom'
import DeleteButton from '../formfields/DeleteButton'
import EnableOrDisableChecklist from './EnableOrDisableChecklist'
import Modal from '../ui-elements/Modal'
import YellowAlert from '../ui-elements/YellowAlert'
import ButtonMenu from '../ui-elements/ButtonMenu'
import ChecklistCategoryNames from './ChecklistCategoryNames'
import { removeNonAlphanumeric } from '../utils/removeNonAlphanumeric'

type Props = {
  thisChecklist: ObjectStringKeyAnyValue
  checklistKey: string
}

function IndividualChecklist({
  thisChecklist,
  checklistKey
}: Props) {

  const {
    tableData,
    sendMessageToWebsocket,
    setShowModal
  } = useContext(GlobalContext)

  const navigate = useNavigate()
  const currentDate = new Date()

  const associatedAssetType = thisChecklist && thisChecklist['AssetTypeId'] && tableData['AssetTypes'] && tableData['AssetTypes'][thisChecklist['AssetTypeId']]
  const cssId = thisChecklist && thisChecklist['ChecklistName'] && removeNonAlphanumeric(thisChecklist['ChecklistName'])


  const deleteChecklist = (checklistId: string) => {
    if (checklistId) {
      setShowModal({ "spinner": 'Saving...' })
      const payload = JSON.stringify({
        action: "checklists",
        subAction: "deleteChecklist",
        checklistId: checklistId
      })
      const unsubscribe = subscribe("checklistDeletedResponse", data => {
        setShowModal(null)
        unsubscribe()
      })
      sendMessageToWebsocket(payload)
    }
  }

  const duplicateChecklist = (checklistId: string) => {
    if (checklistId) {
      setShowModal({ "spinner": 'Duplicating...' })
      const payload = JSON.stringify({
        action: "checklists",
        subAction: "duplicateChecklist",
        checklistId: checklistId
      })
      const unsubscribe = subscribe("checklistDuplicated", data => {
        if (data && data.originalChecklistId === checklistId) {
          setShowModal(null)
          navigate(`/checklists/${data.newChecklistId}`)
        }
        unsubscribe()
      })
      sendMessageToWebsocket(payload)
    }
  }

  if (!thisChecklist) {
    return null
  }


  return <Card id={cssId}>
    <div className={`md:w-80 h-full w-full flex flex-col gap-4 justify-between items-center`}>



      <div className={`w-full text-xs flex flex-col gap-1 pr-10`}>

        <h4 className={`text-base font-righteous text-brandblue text-lg`}>{thisChecklist['ChecklistName'] || 'unnamed checklist'}</h4>

        {associatedAssetType && <div className={`mb-1`}><YellowAlert alignment='left' size='small'>
          {associatedAssetType.DisplayName ?
            `Checklist for asset type: ${associatedAssetType.DisplayName}` :
            `Checklist for asset type Id: ${associatedAssetType.Id}`
          }
        </YellowAlert></div>}

        {
          thisChecklist['Schedule'] &&
          thisChecklist['Schedule']['Frequency'] !== 'ADHOC' &&
          thisChecklist['Schedule']['CheckWindows'] &&
          Object.keys(thisChecklist['Schedule']['CheckWindows']).length > 0 &&
          <p>⏰ {Object.keys(thisChecklist['Schedule']['CheckWindows']).length} check window(s)</p>
        }
        {
          thisChecklist['Schedule'] &&
          thisChecklist['Schedule']['Frequency'] !== 'ADHOC' &&
          thisChecklist['Schedule']['CheckWindows'] &&
          Object.keys(thisChecklist['Schedule']['CheckWindows']).length === 0 &&
          <p>🚨 No check window(s)</p>
        }
        {
          thisChecklist['Schedule'] &&
          thisChecklist['Schedule']['Frequency'] === 'ADHOC' &&
          <p>Ad hoc checklist</p>
        }

        {thisChecklist['requireManagerSignoff'] &&
          <p>🔒 Requires manager signoff</p>}

        <ChecklistCategoryNames
          checklistData={thisChecklist}
          showIfNone={false}
        />


      </div>




    </div>


    <ButtonMenu id={`buttonMenu`}>

      <EnableOrDisableChecklist
        text={'Checklist enabled?'}
        thisChecklist={thisChecklist}
        keyToToggle='isChecklistActive'
      />
      <Button
        internalLinkUrl={`/checklists/${thisChecklist['Id']}`}
        text={`Edit settings`}
        variant={`primary`}
        fullwidth={true}
      //size={`small`}
      />
      <Button
        internalLinkUrl={`/checklists/${thisChecklist['Id']}/questions`}
        text={`Edit questions`}
        variant={`primary`}
        // size={`big`}
        fullwidth={false}
      />
      <Button
        onClick={() => duplicateChecklist(checklistKey)}
        text={`Duplicate`}
        variant={`primary`}
        fullwidth={true}
      />
      <Button
        internalLinkUrl={`/checklists/${thisChecklist['Id']}/results/${currentDate.getFullYear()}/${currentDate.getMonth() + 1}`}
        text={`View results`}
        variant={`primary`}
        fullwidth={true}
      //size={`small`}
      />
      <Button
        internalLinkUrl={`/checklists/${thisChecklist['Id']}/history`}
        text={`Revision history`}
        variant={`primary`}
        fullwidth={true}
      //size={`small`}
      />
      <DeleteButton
        deleteFunction={deleteChecklist}
        functionParams={checklistKey}
        fullwidth={true}
      //size={`small`}
      />
    </ButtonMenu>

  </Card>

}
export default IndividualChecklist